import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortAscending = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4333_4429",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_4333_4429)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M13.9374 21.5688C13.6458 21.2813 13.4999 20.925 13.4999 20.5V9.75L10.1666 13.0833C9.86103 13.3889 9.5045 13.5417 9.097 13.5417C8.68978 13.5417 8.33797 13.3889 8.04159 13.0833C7.73603 12.7869 7.58325 12.4351 7.58325 12.0279C7.58325 11.6204 7.73603 11.2639 8.04159 10.9583L13.9583 5.04167C14.1083 4.90278 14.2708 4.79861 14.4458 4.72917C14.6208 4.65972 14.8083 4.625 15.0083 4.625C15.2083 4.625 15.3958 4.65972 15.5708 4.72917C15.7458 4.79861 15.9027 4.90278 16.0416 5.04167L21.9583 10.9583C22.2638 11.2639 22.4166 11.6111 22.4166 12C22.4166 12.3889 22.2638 12.7428 21.9583 13.0617C21.6527 13.3539 21.2985 13.5 20.8958 13.5C20.493 13.5 20.1388 13.3472 19.8333 13.0417L16.4999 9.75V20.5C16.4999 20.925 16.357 21.2813 16.0712 21.5688C15.7853 21.8563 15.4312 22 15.0087 22C14.5862 22 14.2291 21.8563 13.9374 21.5688Z",
			fill: "#232930"
		}), /* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M23.9582 35.4188C24.0971 35.5654 24.2541 35.6754 24.4291 35.7487C24.6041 35.822 24.7916 35.8586 24.9916 35.8586C25.1916 35.8586 25.3791 35.822 25.5541 35.7487C25.7291 35.6754 25.8916 35.5654 26.0416 35.4188L31.9582 29.1725C32.2638 28.85 32.4166 28.4736 32.4166 28.0434C32.4166 27.6135 32.2638 27.2421 31.9582 26.9292C31.6618 26.6066 31.31 26.4453 30.9028 26.4453C30.4953 26.4453 30.1388 26.6066 29.8332 26.9292L26.4999 30.4482V19.0994C26.4999 18.6507 26.3541 18.2747 26.0624 17.9711C25.7707 17.6676 25.4136 17.5159 24.9911 17.5159C24.5686 17.5159 24.2145 17.6676 23.9286 17.9711C23.6428 18.2747 23.4999 18.6507 23.4999 19.0994V30.4482L20.2082 26.9292C19.9027 26.6066 19.5485 26.4453 19.1457 26.4453C18.7429 26.4453 18.3888 26.5996 18.0832 26.9081C17.7777 27.2447 17.6179 27.6264 17.6041 28.0531C17.5902 28.4795 17.736 28.8526 18.0416 29.1725L23.9582 35.4188Z",
			fill: "#232930"
		})]
	})]
});
export default SvgSortAscending;
